// C:\Users\aleja\Code\inventory_analytics\src\front\src\store\flux\userActivityActions.js
import getApiBaseUrl from "../../utils/api";

const API_URL = getApiBaseUrl();

const userActivityActions = ({ getStore, getActions, setStore }) => ({
  getUserActivity: async (filters = {}) => {
    try {
      const { token } = getStore();
      const params = new URLSearchParams();

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          params.append(key, value);
        }
      });

      const queryString = params.toString();
      const url = `${API_URL}/api/user-activity${
        queryString ? `?${queryString}` : ""
      }`;

      const response = await fetch(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      const error = await getActions().handleApiError(response);
      if (error) {
        return { success: false, data: [], error: "Request failed" };
      }

      const responseData = await response.json();

      if (!responseData.success) {
        getActions().showToast(
          responseData.error || "Error cargando actividad de usuarios",
          "error",
        );
        setStore({ userActivityLogs: [] });

        return {
          success: false,
          data: [],
          error: responseData.error || "Error cargando actividad de usuarios",
        };
      }

      const logs = Array.isArray(responseData.data) ? responseData.data : [];

      setStore({
        userActivityLogs: logs,
      });

      return {
        success: true,
        data: logs,
        error: null,
      };
    } catch (error) {
      console.error("User activity error:", error);
      getActions().showToast("Error cargando actividad de usuarios", "error");

      return {
        success: false,
        data: [],
        error: "Error cargando actividad de usuarios",
      };
    }
  },
});

export default userActivityActions;
